var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12C21.5 16.9706 17.4706 21 12.5 21C11.3029 21 10.1603 20.7663 9.11549 20.3419C8.91552 20.2607 8.81554 20.2201 8.73472 20.202C8.65566 20.1843 8.59715 20.1778 8.51613 20.1778C8.4333 20.1778 8.34309 20.1928 8.16265 20.2229L4.60476 20.8159C4.23218 20.878 4.04589 20.909 3.91118 20.8512C3.79328 20.8007 3.69933 20.7067 3.64876 20.5888C3.59098 20.4541 3.62203 20.2678 3.68413 19.8952L4.27711 16.3374C4.30718 16.1569 4.32222 16.0667 4.32221 15.9839C4.3222 15.9028 4.31572 15.8443 4.298 15.7653C4.27988 15.6845 4.23927 15.5845 4.15806 15.3845C3.73374 14.3397 3.5 13.1971 3.5 12C3.5 7.02944 7.52944 3 12.5 3C17.4706 3 21.5 7.02944 21.5 12Z",
    fill: "#B4B8BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.586033dc009137f1df608bde100c9abb.svg";
export { ForwardRef as ReactComponent };